import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Field } from 'formik'

export const RolesGroup = styled.div`
  color: ${themeGet('colors.darkGray')};
  margin-bottom: 2.5rem;
`

export const Header = styled.h2`
  color: #25282a;
  font-family: ${themeGet('fontFamily')};
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
`

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 0.75rem;
`

interface RoleLabelProps {
  disabled?: boolean
}

export const RoleLabel = styled.label<RoleLabelProps>`
  font-family: ${themeGet('fontFamily')};
  color: #1f1f1f;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: -4px;
  opacity: ${props => (props.disabled ? '60%' : '100%')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};

  & input {
    margin-right: 0.4375rem;
  }
`

export const RadioRoleField = styled(Field)`
  accent-color: ${themeGet('colors.blue')};
`

interface RoleDescriptionUnorderedListProps {
  isAdminRoleAndMultipleMode?: boolean
}

export const RoleDescriptionUnorderedList = styled.ul<RoleDescriptionUnorderedListProps>`
  font-family: ${themeGet('fontFamily')};
  color: #1f1f1f;
  letter-spacing: 0;
  line-height: 20px;
  margin: 0 0 0 1.75rem;
  padding: 0;
  opacity: ${props => (props.isAdminRoleAndMultipleMode ? '60%' : '100%')};
`
